import {
  Avatar,
  Box,
  Card,
  Drawer,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import Zoom from "react-medium-image-zoom";
import FileAttachComponent from "views/page/components/FileAttachComponent";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import config from "configs/config";
import Resizer from "react-image-file-resizer";
import { useMaterialUIController } from "context";
import Swal from "sweetalert2";
import getText from "Translator";
import { setLoading } from "context";
import { setHeader } from "context";
import { setAction } from "context";
import { getFileWithID } from "controllers/FileController";
import { errorMessage } from "components/AlertComponent";
import { updateComment } from "controllers/ForumController";
import { getAllForumFromServerWithFileID } from "controllers/ForumController";
import { sendCommentToServer } from "controllers/ForumController";
import { getResultPageFromServer } from "controllers/PageController";
import InfiniteScroll from "react-infinite-scroll-component";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import GetAppIcon from "@mui/icons-material/GetApp";
import SendIcon from "@mui/icons-material/Send";
import { selectForum } from "controllers/ForumController";
import { deleteForum } from "controllers/ForumController";

let openFrom = "";
let startForum = false;
let pCode = "";
let pName = "";
let refDate = "";
let sumheight = 0;

let emptyState = {
  resultText: "",
  pageTitle: "",
  forumList: [],
  commentText: "",
  attachedList: [],
  attachedIconVisible: false,
  isForumAdmin: false,
  isMyComment: false,
  selectedFile: "",
  selectedForum: {},
  isLoading: false,
  count: 0,
  page: 1,
};

let directory;
let rowsPerPage = 10;
export default function Chat(props) {
  const [details, setDetails] = useState(emptyState);
  const [mode, setMode] = useState("menu");
  const [commentMode, setCommentMode] = useState("new");
  const [reload, setReload] = useState(new Date());
  const [open, setOpen] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const { file, forumGroup } = props;
  const fileUploader = useRef(null);

  const iniComponent = async () => {
    await createForum("");
  };
  const createForum = async (search) => {
    try {
      setLoading(dispatch, true);
      let resultFile = await getFileWithID(file, controller); //realm.objects(tblFile).filtered('id = $0', file);

      if (resultFile.success) {
        resultFile = resultFile.data;

        pCode = resultFile.patientNationalCode;
        pName = resultFile.patientName + " " + resultFile.patientFamily;

        refDate = resultFile.sendToForumDate + "";
        if (refDate.length < 10) {
          refDate = new Date();
        }
        let uploadedFiles = [];

        let isForumAdmin = true;

        let newStates = details;
        newStates.resultText =
          openFrom !== "deletedforum" ? resultFile.resultText : "";
        newStates.attachedIconVisible = uploadedFiles.length > 0 ? true : false;
        newStates.attachedList = uploadedFiles.length > 0 ? uploadedFiles : [];
        newStates.shareIconVisible = pCode.length > 9 ? true : false;
        newStates.isForumAdmin = isForumAdmin.length > 0 ? true : false;
        setDetails(newStates);
      }

      if (startForum) {
        if (openFrom !== "deletedforum") {
        }
        startForum = false;
      }

      await displayForum(rowsPerPage, 1, true);
      setLoading(dispatch, false);
    } catch (err) {
      console.log(err);
    }
  };
  const scrollToBottom = () => {};
  const displayForum = async (perPage, page, clear = false) => {
    try {
      setLoading(dispatch, true);
      let newData = {
        file,
        forumGroup,
        perPage,
        page,
      };
      let data = await getAllForumFromServerWithFileID(newData, controller);
      console.log("getAllForumFromServerWithFileID'", data);
      if (data.success) {
        let tempDatas;
        if (clear) {
          tempDatas = data.data;
        } else {
          tempDatas = details.forumList.concat(data.data);
        }
        let newStates = details;
        newStates.pageMode = "chat";
        details.forumList = tempDatas;
        details.count = data.count;
        details.page = details.page + 1;
        setDetails(newStates);
        setReload(new Date());

        setLoading(dispatch, false);
      } else {
        Swal.fire({
          title: "Warning",
          text: data.message,
          confirmButtonText: getText("ok", "fa"),
          icon: "error",
        });
        if (data.errorCode === 101) {
          props.history.replace("/");
        }
      }
    } catch (err) {
      console.log(err);
      errorMessage(getText("generalerror", "fa"), 2005);
    }
  };
  const sendComment = async () => {
    if (details.commentText.length === 0 && details.selectedFile.length === 0) {
      Swal.fire({
        title: getText("warning", "fa"),
        text: getText("emptyalert", "fa"),
        confirmButtonText: getText("ok", "fa"),
        // confirmButtonTitle: getText('ok', "fa"),
        // confirmButtonColor: '#039dfc',
        // style: 'error',
        // cancellable: false,
      });

      return;
    }
    setLoading(dispatch, true);
    if (commentMode == "new") {
      let newForum = {
        file: file,
        capsule: props.capsule,
        comment: details.commentText,
        replyFrom: props.fileInfo.id,
        selected: false,
        forumGroup: forumGroup,
        isShow: true,
        username: controller.id,
      };
      let sent;
      try {
        //x props.socket.emit('chatmessage', newForum)
        sent = await sendCommentToServer(
          newForum,
          details.selectedFile,
          controller
        );
      } catch (err) {}
      if (sent.success) {
        let temp = details;
        temp.commentText = "";
        temp.selectedFile = "";
        setDetails(temp);
        await displayForum(rowsPerPage, 1, true);
        setLoading(dispatch, false);
      } else {
        Swal.fire({
          title: getText("warning", "fa"),
          text: getText("checkintenetconnection", "fa"),
          confirmButtonText: getText("ok", "fa"),
          // confirmButtonTitle: getText('ok', "fa"),
          // confirmButtonColor: '#039dfc',
          // style: 'error',
          // cancellable: false,
        });
        setLoading(dispatch, false);
        return;
      }
    } else {
      let newForum = {
        id: details.selectedForum.id,
        comment: details.commentText,
      };
      let update = await updateComment(newForum, controller);
      if (update.success) {
        let temp = details;
        temp.commentText = "";
        temp.selectedFile = "";

        setDetails(temp);
        setCommentMode("new");
        await displayForum(rowsPerPage, 1, true);
        setLoading(dispatch, false);
      } else {
        let temp = details;
        temp.commentText = "";
        temp.selectedFile = "";

        setDetails(temp);
        setCommentMode("new");
        Swal.fire({
          title: getText("warning", "fa"),
          text: getText("checkintenetconnection", "fa"),
          confirmButtonText: getText("ok", "fa"),
          // confirmButtonTitle: getText('ok', "fa"),
          // confirmButtonColor: '#039dfc',
          // style: 'error',
          // cancellable: false,
        });
        setLoading(dispatch, false);
        return;
      }
    }
    scrollToBottom();
    //  Keyboard.dismiss();
  };
  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        700,
        700,
        "JPEG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });
  const handleSelectFile = async (event) => {
    let newDetails = details;
    newDetails.selectedFile = event.target.files[0];
    if (event.target.files[0].type) {
      if (event.target.files[0].type.toLowerCase().includes("image")) {
        if (event.target.files[0].size > 500000) {
          newDetails.selectedFile = await resizeFile(event.target.files[0]);
        }
      } else {
        if (event.target.files[0].size > 500000) {
          Swal.fire({
            title: getText("warning", "fa"),
            text: getText("filesizewarning", "fa"),
            confirmButtonText: getText("ok", "fa"),
          });

          return;
        }
      }
    }

    setDetails(newDetails);
    setReload(new Date());
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    //x props.socket.on('tx', (msg) => {
    //x })
    //x props.socket.on('message', (msg) => {
    //x      if (controller.id + '' !== msg.username + '' && msg.forumGroup === props.forumGroup) {
    //x         displayForum(rowsPerPage, 1, true);
    //x     }
    //x })
  }, [props.socket]);
  useEffect(() => {
    (async () => {
      setDetails(emptyState);
      setReload(new Date());

      //x props.socket.emit('joinroom', { username: controller.id, roomname: props.forumGroup + '' })
      setHeader(dispatch, "backpage-dispalyresult-attach");

      iniComponent();
    })();
    return () => {
      setAction(dispatch, "");

      //x props.socket.emit('leftroom', controller.id)
      setDetails();
      // props.socket.disconnect()
    };
  }, []);
  useEffect(() => {
    (async () => {
      if (controller.action) {
        if (controller.action.startsWith("attach")) {
          setMode("attach");
          setOpen(true);
        } else if (controller.action.startsWith("dispalyresult")) {
          let datas = {
            fileInfo: props.fileInfo,
          };

          let result = await getResultPageFromServer(datas, controller);

          if (result.success) {
            let text = "<b>";
            text += getText("summary", "fa");
            text += ":</b>" + result.resultText;

            text += ":<br /><b>";
            text += getText("mysuggestion", "fa");
            text += ":</b><br />" + result.myQuestion;
            Swal.fire({
              title: "",
              html: text,
              confirmButtonText: getText("ok", "fa"),
            });
            // setResultText(result.resultText + '  ');
            // setMySuggestion(result.myQuestion);
          } else {
            Swal.fire({
              title: "",
              text: getText("warningalert", "fa"),
              confirmButtonText: getText("ok", "fa"),
            });
          }
        }
        setAction(dispatch, "");
      }
    })();
  }, [controller.action]);
  return (
    <>
      <input
        type="file"
        id="file"
        ref={fileUploader}
        accept="audio/*,video/*,image/*"
        onChange={handleSelectFile}
        style={{ display: "none" }}
      />

      {props.fileInfo && (
        <>
          <div
            id="scrollableDiv"
            style={{
              paddingLeft: 5,
              paddingRight: 5,
              height: "calc(100% - 155px)", //document.getElementById('root').clientHeight - 153,
              overflow: "auto",
              display: "flex",
              flexDirection: "column-reverse",
              top: 58,
              position: "fixed",
              right: 0,
              left: 0,
            }}
          >
            <InfiniteScroll
              dataLength={details.forumList.length}
              hasMore={details.count > details.forumList.length ? true : false}
              // loader={<h4>{getText('getdatas', "fa")}</h4>}
              loader="..."
              scrollableTarget="scrollableDiv"
              style={{ display: "flex", flexDirection: "column-reverse" }} //To put endMessage and loader to the top.
              next={() => {
                displayForum(rowsPerPage, details.page, false);
              }}
              inverse={true}
            >
              {details.forumList &&
                details.forumList.map((item, index) => (
                  <Card key={item.id} style={{ marginTop: 1, marginBottom: 2 }}>
                    <div style={{ margin: 5 }}>
                      <div style={{ display: "flex" }}>
                        <Avatar
                          style={{ width: 30, height: 30 }}
                          alt={item.name}
                          src={config.fileserver + "/images/" + item.picture}
                        />
                        <div
                          style={{
                            width: "90%",
                            lineHeight: "30px",
                            marginLeft: 10,
                            marginRight: 10,
                            color: "#039dfc",
                            fontWeight: "bold",
                            fontSize: 11,
                          }}
                        >
                          {item.name + " - " + item.time}
                          {item.selected && (
                            <DoneAllIcon style={{ fontSize: 13 }} />
                          )}
                        </div>
                        <Box style={{ alignItems: "end" }}>
                          {(item.user === controller.id ||
                            (controller.userRole + "").toLowerCase() ===
                              "admin" ||
                            details.isForumAdmin === true ||
                            props.isForumAdmin === true) && (
                            <IconButton
                              color="primary"
                              aria-label="attach"
                              onClick={() => {
                                let newStates = details;
                                newStates.selectedForum = item;
                                newStates.isMyComment =
                                  item.user + "" === controller.id + ""
                                    ? true
                                    : false;
                                setDetails(newStates);
                                setReload(new Date());
                                setMode("menu");
                                setOpen(true);
                              }}
                            >
                              <MoreVertIcon />
                            </IconButton>
                          )}
                        </Box>
                      </div>
                      <div
                        style={{
                          dir: "auto",
                          textAlign: "start",
                          fontSize: "16px",
                        }}
                      >
                        <div
                          style={{ width: "100%", dir: "auto" }}
                          dangerouslySetInnerHTML={{
                            __html: item.text
                              ? item.text.replace(/\n/g, "<br />")
                              : "",
                          }}
                        />
                      </div>
                      {item.attachFile && item.attachFile !== "" && (
                        <Box display="flex" justifyContent="flex-end">
                          <Box p={1}>
                            {item.attachType === "doc" && (
                              <a
                                href={
                                  config.fileserver +
                                  "/forum/" +
                                  item.attachFile
                                }
                                download
                              >
                                <Avatar
                                  style={{
                                    width: 50,
                                    height: 50,
                                    color: "#039dfc",
                                  }}
                                  alt={item.name}
                                  src={
                                    config.fileserver +
                                    "/forum/" +
                                    item.attachFile
                                  }
                                >
                                  <GetAppIcon />
                                </Avatar>
                              </a>
                            )}
                            {item.attachType === "image" && (
                              <Zoom>
                                <Avatar
                                  style={{
                                    width: 75,
                                    height: 75,
                                    borderRadius: 1,
                                  }}
                                  alt={item.name}
                                  src={
                                    config.fileserver +
                                    "/forum/" +
                                    item.attachFile
                                  }
                                >
                                  <GetAppIcon />
                                </Avatar>
                              </Zoom>
                            )}
                          </Box>
                        </Box>
                      )}
                    </div>
                  </Card>
                ))}
            </InfiniteScroll>
          </div>

          <Paper
            component="form"
            style={{
              padding: "1px 4px",
              display: "flex",
              alignItems: "center",
              margin: 0,
              left: 0,
              with: "100% !important",
              right: 0,
              bottom: 50,
              position: "fixed",
              borderRadius: 0,
              backgroundColor: "#ffc7d4",
              zIndex: 999,
            }}
          >
            {"fa" === "en" && commentMode == "new" && (
              <>
                {details.selectedFile === "" && (
                  <IconButton
                    color="primary"
                    aria-label="attach"
                    onClick={() => {
                      fileUploader.current.click();
                    }}
                  >
                    <AttachFileOutlinedIcon />
                  </IconButton>
                )}
                {details.selectedFile !== "" && (
                  <div>
                    <IconButton aria-label="menu">
                      <Avatar
                        style={{ width: 35, height: 35 }}
                        alt="s"
                        src={URL.createObjectURL(details.selectedFile)}
                      />

                      <CloseIcon
                        onClick={() => {
                          let newStates = details;
                          newStates.selectedFile = "";
                          setDetails(newStates);
                          setReload(true);
                        }}
                        style={{
                          color: "#039dfc",
                          width: 15,
                          height: 15,
                          position: "fixed",
                        }}
                      />
                    </IconButton>
                  </div>
                )}
              </>
            )}
            {"fa" === "fa" && (
              <>
                <IconButton
                  color="primary"
                  aria-label="sendComment"
                  onClick={() => {
                    sendComment();
                  }}
                >
                  <SendIcon />
                </IconButton>
              </>
            )}
            <InputBase
              multiline={true}
              maxRows={6}
              className="input"
              value={details.commentText}
              onChange={(event) => {
                let newStates = details;
                newStates.commentText = event.target.value;
                setDetails(newStates);
                setReload(new Date());
              }}
            />
            {"fa" === "fa" && commentMode == "new" && (
              <>
                {details.selectedFile === "" && (
                  <IconButton
                    color="primary"
                    aria-label="attach"
                    onClick={() => {
                      fileUploader.current.click();
                    }}
                  >
                    <AttachFileOutlinedIcon />
                  </IconButton>
                )}
                {details.selectedFile !== "" && (
                  <div>
                    <IconButton aria-label="menu">
                      <Avatar
                        style={{ width: 35, height: 35 }}
                        alt="s"
                        src={URL.createObjectURL(details.selectedFile)}
                      />

                      <CloseIcon
                        onClick={() => {
                          let newStates = details;
                          newStates.selectedFile = "";
                          setDetails(newStates);
                          setReload(true);
                        }}
                        style={{
                          color: "#039dfc",
                          width: 15,
                          height: 15,
                          position: "fixed",
                        }}
                      />
                    </IconButton>
                  </div>
                )}
              </>
            )}
            {"fa" === "en" && (
              <>
                <IconButton
                  color="primary"
                  aria-label="sendComment"
                  onClick={() => {
                    sendComment();
                  }}
                >
                  <SendIcon />
                </IconButton>
              </>
            )}
          </Paper>
          <Drawer
            anchor="bottom"
            open={open}
            onClose={() => {
              setOpen(false);
            }}
          >
            <div className="drawertitle">
              <IconButton
                style={{
                  color: "#039dfc",
                  height: 35,
                  width: 35,
                  top: 5,
                  backgroundColor: "#FFF",
                  position: "absolute",
                  right: 5,
                }}
                className="iconButton"
                aria-label="CloseIcon"
                onClick={() => {
                  setOpen(false);
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
            <div
              className={
                "fa" === "en" ? "drawertext" : "drawertext rtl"
              }
            >
              {mode === "menu" && (
                <List>
                  {(details.isMyComment === true ||
                    (controller.userRole + "").toLowerCase() === "admin" ||
                    props.isForumAdmin === true ||
                    details.isForumAdmin === true) && (
                    <ListItem
                      key="deleteforum"
                      button
                      onClick={() => {
                        Swal.fire({
                          title: getText("warning", "fa"),
                          text: getText("deleteconfirm", "fa"),
                          cancelButtonText: getText("no", "fa"),
                          confirmButtonText: getText("yes", "fa"),
                          showCancelButton: true,
                        }).then(async (result) => {
                          if (result.isConfirmed) {
                            let newData = {
                              forumid: details.selectedForum.id,
                            };
                            let resultres = await deleteForum(
                              newData,
                              controller
                            );
                            if (resultres.success) {
                              var array = [...details.forumList];
                              var index = array.indexOf(details.selectedForum);
                              if (index !== -1) {
                                let newStates = details;
                                array.splice(index, 1);
                                newStates.forumList = array;

                                setDetails(newStates);
                                setReload(new Date());
                              }
                            } else {
                              Swal.fire({
                                text: getText(
                                  "probleminproccess",
                                  "fa"
                                ),
                                position: "bottom-end",
                                background: "#f1b3af",
                                showConfirmButton: false,
                                timer: 1500,
                              });
                            }
                          }
                          setOpen(false);
                        });
                      }}
                    >
                      <ListItemText
                        primary={getText("delete", "fa")}
                      />
                    </ListItem>
                  )}
                  <ListItem
                    key="editforum"
                    button
                    onClick={() => {
                      setCommentMode("edit");
                      let newStates = details;
                      newStates.commentText = details.selectedForum.text;
                      setDetails(newStates);
                      setReload(new Date());
                      setOpen(false);
                    }}
                  >
                    <ListItemText primary={getText("edit", "fa")} />
                  </ListItem>
                  {(details.isForumAdmin === true ||
                    controller.userRole.toLowerCase() === "admin") && (
                    <ListItem
                      key="selectforum"
                      button
                      onClick={async () => {
                        let newStates;
                        let newData = {
                          selected: !details.selectedForum.selected,
                          forumid: details.selectedForum.id,
                        };
                        let result = await selectForum(newData, controller);
                        if (result.success) {
                          var array = [...details.forumList];
                          var index = array.indexOf(details.selectedForum);
                          if (index !== -1) {
                            array[index].selected =
                              !details.selectedForum.selected;
                            newStates = details;
                            newStates.forumList = array;
                            setDetails(newStates);
                          }
                          newStates = details;
                          newStates.selectedForum = {};
                          setDetails(newStates);
                          setReload(new Date());
                        } else {
                          Swal.fire({
                            text: getText("probleminproccess", "fa"),
                            position: "bottom-end",
                            background: "#f1b3af",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                        }
                        setOpen(false);
                      }}
                    >
                      {!details.selectedForum.selected && (
                        <ListItemText
                          primary={getText("selectcomment", "fa")}
                        />
                      )}
                      {details.selectedForum.selected && (
                        <ListItemText
                          primary={getText("unselectcomment", "fa")}
                        />
                      )}
                    </ListItem>
                  )}
                </List>
              )}
              {mode === "attach" && (
                <FileAttachComponent
                  from="chat"
                  props={props}
                  file={props.fileInfo.file}
                  handleClose={handleClose}
                />
              )}
            </div>
          </Drawer>
        </>
      )}
    </>
  );
}
